import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import financialPlanningImageDesktopWebp from './images/couple-hugging-desktop.webp';
import financialPlanningImageMobileWebp from './images/couple-hugging-mobile.webp';
// Styles
import { BulletedListStyled } from './styles';

export default () => {
  return (
    <InformationalModule
      // configs
      sectionId='insurance-financial-planning-2'
      backgroundVariant='lightC'
      moduleName='financial-planning-module'
      moduleVariation='A'
      reverseContent
      // content
      subHeadingText={
        <>
          Put money back into your pocket with <WidowBlock>insurance dividends.</WidowBlock>
        </>
      }
      // column content
      columnContentA={(
        <>
          <Typography nextElement='button'>
            Dividends are given out when our earnings turn out better than we thought they would when premiums were set, and benefits established.<sup>5</sup> As a mutual company, we don&#39;t have stockholders so instead of paying dividends to Wall Street, we pay them to our policyowners. Even though they&#39;re not guaranteed, we&#39;ve paid dividends every year since 1872. Here&#39;s what you can use them for:
          </Typography>
          <BulletedListStyled
            bulletedListData={[
              { bulletText: 'Anything you want (when you take it as cash)' },
              { bulletText: 'Paying your premiums' },
              { bulletText: 'Increasing your coverage' },
            ]}
            bulletType='checkmark'
            disableBottomPadding
            themeType= 'lightTheme'
          />
          <Link
            id='insurance-financial-planning-2-section-watch-video'
            variant='buttonLinkPrimary'
            isOutgoingLink
            ariaLabel='watch the Dividends 101: What You Need to Know video'
            linkUrl='https://www.youtube.com/watch?v=est-gkZQ9J4/'>
            Watch video
          </Link>
        </>
      )}
      // image props
      imageAltText='A happy couple hugging eachother'
      imageSrcDefault={financialPlanningImageDesktopWebp.toString()}
      imageSrcMobile={financialPlanningImageMobileWebp.toString()}
    />
  );
};
